"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollToElementById = void 0;
const dom_utils_1 = require("../../utils/dom-utils");
const scrollToElementById = (id) => {
    const element = (0, dom_utils_1.elementId)(id);
    element
        ? element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
        : console.error(`Element with ID '${id}' not found.`);
};
exports.scrollToElementById = scrollToElementById;
